import React from "react";
import PropTypes from "prop-types";

const defaultButton = props => <button {...props}>{props.children}</button>;

export default class SellerGroupModelListPagination extends React.Component {
  constructor(props) {
    super(props);
    this.changePage = this.changePage.bind(this);
    this.state = {
      visiblePages: this.getVisiblePages(null, props.pages)
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.pages !== nextProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(null, nextProps.pages)
      });
    }
  }

  static propTypes = {
    pages: PropTypes.number,
    page: PropTypes.number,
    PageButtonComponent: PropTypes.any,
    onPageChange: PropTypes.func,
    previousText: PropTypes.string,
    nextText: PropTypes.string
  };

  getVisiblePages = (page, total) => {
    let start = 1;
    return [...Array(total).keys()].map(v => start+v);
  };

  changePage = (page) => {
    // ReactTable props onPageChange is 0-indexed subtract 1
    this.props.onPageChange(page - 1);
  }

  render() {
    const { PageButtonComponent = defaultButton } = this.props;
    const { visiblePages } = this.state;

    const currentPage = (this.props.page + 1);  // props.page is 0-indexed use actual number for current page
    function createPrevIcon() {
      // only display prev icon if there are multiple pages
      if (visiblePages !== undefined && visiblePages.length > 0 && currentPage > 1) {
        return {__html: '<i class="fa fa-chevron-left"></i>'};
      } 
    }
    function createNextIcon() {
      // only display next icon if there are multiple pages AND not the last page
      if (visiblePages !== undefined && visiblePages.length > 1 && visiblePages.length != currentPage) {
        return {__html: '<i class="fa fa-chevron-right"></i>'};
      }
    }

    function isPageWithinRange(arrayIndex) {
      let currentPageIndex = currentPage-1;

      let prev3Pages = currentPageIndex-3;
      let next3Pages = currentPageIndex+3;

      // if it's few pages then pad the next few pages with what's missing from current page
      if (prev3Pages < 0) {
        next3Pages = next3Pages + (prev3Pages * -1)
      }


      // if it's last pages then pad the previous with (last page minus next 3 pages)
      let lastPage = visiblePages.length -1;
      if (lastPage < next3Pages) {
        prev3Pages = prev3Pages - (next3Pages - lastPage);
      }

      return arrayIndex <= next3Pages  && arrayIndex >= prev3Pages
    }

    if (visiblePages.length <= 1) {
      // no visible pages, do not render page section
      return (null)
    }

    return (
      <div className="ReactTable__pagination">
        <div className="ReactTable__prevPageWrapper">
          <PageButtonComponent
            className="ReactTable__pageButton"
            onClick={() => {
              if (currentPage === 1) return;
              this.changePage(currentPage - 1);
            }}
            disabled={currentPage === 1}
          >
            <span dangerouslySetInnerHTML={createPrevIcon()}></span>
          </PageButtonComponent>
        </div>
        <div className="ReactTable__visiblePagesWrapper">
          { visiblePages.length > 1 && visiblePages.map((page, index, array) => {

            return ( isPageWithinRange(index) && 
              <PageButtonComponent
                key={page}
                className={
                  (currentPage === page
                    ? "ReactTable__pageButton ReactTable__pageButton--active"
                    : "ReactTable__pageButton")
                }
                onClick={this.changePage.bind(this, page)}
              >
                {page}
              </PageButtonComponent>
            );
          })}
        </div>
        <div className="ReactTable__nextPageWrapper">
          <PageButtonComponent
            className="ReactTable__pageButton"
            onClick={() => {
              if (currentPage === this.props.pages) return;
              this.changePage(currentPage + 1);
            }}
            disabled={currentPage === this.props.pages}
          >
            <span dangerouslySetInnerHTML={createNextIcon()}></span>
          </PageButtonComponent>
        </div>
      </div>
    );
  }
}